<template>
  <div class="admin-area">
    <div class="text-center">
      <v-container>
        <v-row align-content="center" justify="center">
          <v-col xs="12" sm="12" md="12" lg="12" xl="12">
            <p class="text-h5">
              <span style="font-weight: bold">Gérer Pollen Photos</span>
            </p>
          </v-col>
        </v-row>
        <v-row align-content="center" justify="center">
          <v-col xs="12" sm="12" md="12" lg="12" xl="12">
            <v-expansion-panels multiple v-model="panel">
              <v-expansion-panel>
                <v-expansion-panel-header
                  ><v-list-item>
                    <v-list-item-icon>
                      <!--  <v-icon>{{ item.icon }}</v-icon> -->
                      <v-avatar color="#f7f3e3" size="30">F</v-avatar>
                    </v-list-item-icon>
                    <v-list-item-content>Gérer les familles</v-list-item-content>
                  </v-list-item></v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <CrudFamille></CrudFamille>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                    <v-list-item>
                    <v-list-item-icon>
                      <!--  <v-icon>{{ item.icon }}</v-icon> -->
                      <v-avatar color="#f7f3e3" size="30">G</v-avatar>
                    </v-list-item-icon>
                    <v-list-item-content>Gérer les genres</v-list-item-content>
                  </v-list-item></v-expansion-panel-header>
                <v-expansion-panel-content>
                  <CrudGenre></CrudGenre>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                    <v-list-item>
                    <v-list-item-icon>
                      <!--  <v-icon>{{ item.icon }}</v-icon> -->
                      <v-avatar color="#f7f3e3" size="30">M</v-avatar>
                    </v-list-item-icon>
                    <v-list-item-content>Gérer les mots-clés</v-list-item-content>
                  </v-list-item></v-expansion-panel-header>
                <v-expansion-panel-content>
                  <CrudMotcle></CrudMotcle>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header
                  ><v-list-item>
                    <v-list-item-icon>
                      <!--  <v-icon>{{ item.icon }}</v-icon> -->
                      <v-avatar color="#f7f3e3" size="30">P</v-avatar>
                    </v-list-item-icon>
                    <v-list-item-content>Gérer les espèces</v-list-item-content>
                  </v-list-item></v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <CrudEspece></CrudEspece>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import CrudFamille from "./CrudFamille.vue";
import CrudGenre from "./CrudGenre.vue";
import CrudEspece from "./CrudEspece.vue";
import CrudMotcle from './CrudMotcle.vue';
import { mapActions} from "vuex";
export default {
  components: {
    CrudFamille,
    CrudGenre,
    CrudEspece,
    CrudMotcle,
  },
  data() {
    return { panel: [3] };
  },
  methods: {
     ...mapActions([
      "fetchPollens",
      "fetchFamille",
      "fetchGenre",
      "fetchImages",
      "fetchCaracterise",
      "fetchCharacteristique",
      "fetchMotcle",
    ]),
    loadData(){
      this.fetchPollens();
      this.fetchFamille();
      this.fetchGenre();
      this.fetchImages();
      this.fetchCaracterise();
      this.fetchCharacteristique();
      this.fetchMotcle();
    }
  },
  created() {
    this.loadData();
  },
};
</script>